module.exports = __webpack_public_path__ + "static/img/2_1_1_3.0a8e9a31.jpg";